import React from 'react';
import { connect } from 'react-redux';
import { AppDispatch } from 'reducers/index';
import { browserHistory } from 'react-router';

import { hideModal } from 'cards/actions/modalActions';

import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import TrashBin from 'assets/images/digitalSaveTheDate/trashbin-circle.svg';
import { moveToDrafts } from 'cards/actions/digitalOrdersActions';
import { BUSINESS_UNIT } from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';
import { movePublishedToDrafts } from 'cards/actions/draftsAndOrdersRedesignActions';
import { trackEvent } from '../../../../../util/trackingHelper';
import FeatureFlags from '../../../../../util/featureFlags';

import styles from './styles.module.less';

export type DigitalMoveToDraftsModalProps = {
  closeModal: () => void;
  onMoveToDraft: (projectUUID: string) => void;
  projectUUID: string;
  redirect?: boolean;
};

const DigitalMoveToDraftsModal = ({
  closeModal,
  onMoveToDraft,
  projectUUID,
  redirect,
}: DigitalMoveToDraftsModalProps) => {
  const moveDrafts = () => {
    trackEvent('CTA Clicked', {
      business_unit: BUSINESS_UNIT.DIGITAL_SAVE_THE_DATE,
      cta_type: 'BUTTON',
      cta: 'MOVE_TO_DRAFTS',
    });
    // @ts-ignore
    onMoveToDraft(projectUUID).then(() => {
      if (redirect) {
        if (FeatureFlags.get('updateDSTDRoutes')) {
          browserHistory.push(`/wedding-planning/projects/digital`);
        } else {
          browserHistory.push(`/wedding-planning/projects/drafts-and-orders`);
        }
      }
      closeModal();
    });
  };

  return (
    <div className={styles.container}>
      <img src={TrashBin} alt="Trash bin" />
      <div className={styles.header}>
        Heads up! Moving published cards back to drafts takes them offline.
      </div>
      <div className={styles.content}>
        <div>
          If you&apos;ve already shared the link with guests, they&apos;ll no longer be able to
          access it.
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <ButtonV2 onClick={closeModal} variant="secondary">
          Cancel
        </ButtonV2>
        <ButtonV2 onClick={moveDrafts} className={styles.buttonSpacing}>
          Got It, Move
        </ButtonV2>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  closeModal: () => dispatch(hideModal()),
  onMoveToDraft: (projectUUID: string) =>
    dispatch(moveToDrafts(projectUUID)).then(() => dispatch(movePublishedToDrafts(projectUUID))),
});

export default connect(null, mapDispatchToProps)(DigitalMoveToDraftsModal);
